<template>
  <div>
    <!-- NOT USED? -->
    <div class="accordion-container clearfix">
      <div class="title clearfix" v-on:click="onExpand">
        <v-icon class="info-icon" color="primary">{{icon}}</v-icon>
        <p>{{ title }}</p>
      </div>
      <div class="icon">
        <v-icon color="primary">$vuetify.icons.expand</v-icon>
      </div>
    </div>
    <div class="accordion-content" v-bind:class="{ displayed: isExpanded, hidden: !isExpanded }">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import Vuetify from "vuetify";

export default {
  name: "WesInfoAccordion",
  props: {
    title: String,
    icon: String,
    isExpanded: Boolean
  },
  methods: {
    onExpand: function (event) {
      this.$emit("expand", {});
    }
  },
  watch: {
    // whenever question changes, this function will run
    isExpanded: function (newVal, oldVal) {
      let e = newVal;
    }
  }
};
</script>

<style scoped>
.info-icon {
  float: left;
  border-radius: 50%;
  text-align: center;
  padding: 5px 5px 5px 10px;
  color: #13314f;
  font-size: smaller;
}
.accordion-container {
  width: 100%;
  /*margin: 2px 0;*/
  border: 2px solid #13314f;
  min-height: 50px;
  border-radius: 5px;
  background-color: #f5f5f5;
}
.accordion-container:hover {
  cursor: pointer;
}
.title {
  font-weight: bold;
  float: left;
  width: 90%;
  text-align: left;
  padding: 8px;
}
.title > p {
  margin: 0 0 0 5px;
  float: right;
  text-align: left;
  width: 96%;
  line-height: 32px;
  font-size: 16px;
}
.icon {
  float: right;
  width: 5%;
  margin: 11px 0;
}
.accordion-content {
  min-height: 50px;
}
.displayed {
  display: block;
}
.hidden {
  display: none;
}
</style>
